import React, { useState, useMemo } from 'react';
import { ChevronUp, ChevronDown, Search, ChevronLeft, ChevronRight, Table2, X } from 'lucide-react';

const CurrentStockPosition = ({ data = [] }) => {
  // State management for search, sorting, and pagination
 
  return (
    <div className="w-full space-y-2 p-1 bg-gray-50/50 rounded-xl">
      
        {/* --- TABLE TOGGLE BUTTON --- */}
        <div className="">
        {/* <button
          onClick={() => setShowTable((prev) => !prev)}
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-xs font-semibold bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-colors"
        >
          {showTable ? <X className="w-4 h-4" /> : <Table2 className="w-4 h-4" />}
          {showTable ? 'Hide Stock Table' : 'Show Stock Table'}
        </button> */}
      </div>

      
      {/* --- EXECUTIVE KPI CARDS --- */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
        <div className="bg-white px-4 py-2 rounded-xl border border-gray-200/80 shadow-sm">
          <p className="text-xs text-gray-500 uppercase tracking-wider"> Stock Value</p>
          <p className="text-xl font-bold text-gray-900 mt-1">
            {data &&  data[0]?.Total_Value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
        </div>
        
        <div className="bg-white px-4 py-2  rounded-xl border border-gray-200/80 shadow-sm">
          <p className="text-xs text-gray-500 uppercase tracking-wider">Stock Quantity</p>
          <p className="text-xl font-bold text-gray-900 mt-1">
            {data && data[0]?.Total_Qty.toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </p>
        </div>

        
      </div>

    

     
    </div>
  );
};

export default CurrentStockPosition;